"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTicketPriorityLabel = void 0;
exports.InternalTicketPriorityLabel = {
    '2': 'Critical',
    '1': 'High',
    '0': 'Medium',
    '-1': 'Low',
    '-2': 'Lowest',
};
//# sourceMappingURL=internal-ticket.js.map